module.exports = __webpack_public_path__ + "static/media/elpais.75ef412a.png";